export default {"src":"/_next/static/media/arrow.ca26a17a.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};